import React, { useState, useEffect } from "react";
import "./Shop.scss";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";
import OffcerCard from "../../components/Card/OffcerCard";
import sale from "../../img/video/sale.gif";

const Offer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { price } = location.state || {};
  const [activePrice, setActivePrice] = useState(price || "");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);
  const [sortOrder, setSortOrder] = useState(""); // 'asc' or 'desc'
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [loading, setLoading] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProduct = (price) => {
    navigate("/shop", { state: { price } });
  };

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("/get-all-cetegory");
        setCategories(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCategories();
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        let params = {};
        if (selectedCategory) params.category = selectedCategory;
        if (activePrice) params.price = activePrice;

        const res = await axios.get("/get-flash-sele-product", { params });
        setProducts(res.data);

        // Extract unique brands and sort alphabetically A-Z
        const uniqueBrands = [...new Set(res.data.map((p) => p.brandName))]
          .filter(Boolean) // remove null/undefined
          .sort((a, b) => a.localeCompare(b));

        setBrands(uniqueBrands);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [selectedCategory, activePrice]);

  // Filter by brand and search
  const filteredProducts = products.filter((p) => {
    const matchesBrand = selectedBrand ? p.brandName === selectedBrand : true;
    const matchesSearch = searchTerm
      ? p.name.toLowerCase().includes(searchTerm.toLowerCase())
      : true;
    return matchesBrand && matchesSearch;
  });

  // Sort by price
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortOrder === "asc") {
      // Price: Low → High
      return a.price - b.price;
    }
    if (sortOrder === "desc") {
      // Discount: High → Low
      return b.discount - a.discount;
    }
    return 0;
  });

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="products">
          <div className="right">
            <div className="free_banner">
              <img src={sale} alt="offers banner" />
            </div>
            {sortedProducts.length === 0 ? null : (
              <div className="filter_wrp">
                {/* Category Filter */}
                <div className="__filter" style={{ margin: "5px 0" }}>
                  {/* <label>Filter by Category </label> */}
                  <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="">Filter by Category </option>
                    {categories.map((item) => (
                      <option key={item._id} value={item.category}>
                        {item.category}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Brand Filter */}
                <div className="__filter" style={{ margin: "5px 0" }}>
                  {/* <label>Filter by Brand </label> */}
                  <select
                    value={selectedBrand}
                    onChange={(e) => setSelectedBrand(e.target.value)}
                  >
                    <option value="">Filter by Brand </option>
                    {brands.map((b, i) => (
                      <option key={i} value={b}>
                        {b}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Price Sorting */}
                <div className="__filter" style={{ margin: "5px 0" }}>
                  {/* <label>Sort by Price </label> */}
                  <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                  >
                    <option value="">Sort by Price & Discount </option>
                    <option value="asc">Low to High (Price) </option>
                    <option value="desc">High to Low (Discount ) </option>
                  </select>
                </div>
                <div className="__filter two" style={{ margin: "5px 0" }}>
                  {/* <label>Search </label> */}
                  <div>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Enter product name..."
                    />
                  </div>
                  <div>
                    <button
                      className="reset_btn"
                      onClick={async () => {
                        setSelectedCategory("");
                        setSelectedBrand("");
                        setSortOrder("");
                        setSearchTerm("");
                        setActivePrice(""); // Clear price state

                        try {
                          const res = await axios.get("/get-all-product");
                          setProducts(res.data);

                          const uniqueBrands = [
                            ...new Set(res.data.map((p) => p.brandName)),
                          ];
                          setBrands(uniqueBrands);
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                    >
                      Reset Filter
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Products Display */}

            {loading ? (
              <Loading />
            ) : (
              <div className="">
                {sortedProducts.length === 0 ? (
                  <div className="no_pro">
                    <div className="fl_msg">
                      <h4>
                        ⚡ Flash sale closed. Don’t worry, new deals are on the
                        way — stay tuned!
                      </h4>

                      <h5> Discover more exciting offers below </h5>
                    </div>
                    <div className="offer_wrp">
                      <div
                        className="Img_wrp"
                        onClick={() => handleProduct("3")}
                      >
                        <img
                          src={require("../../img/new_images/3.jpg")}
                          alt=""
                        />
                      </div>
                      <div
                        className="Img_wrp"
                        onClick={() => handleProduct("5")}
                      >
                        <img
                          src={require("../../img/new_images/5.jpg")}
                          alt=""
                        />
                      </div>
                      <div
                        className="Img_wrp"
                        onClick={() => handleProduct("10")}
                      >
                        <img
                          src={require("../../img/new_images/10.jpg")}
                          alt=""
                        />
                      </div>
                      <div
                        className="Img_wrp"
                        onClick={() => handleProduct("15")}
                      >
                        <img
                          src={require("../../img/new_images/15.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="right_in">
                    {sortedProducts.map((product, i) => (
                      <OffcerCard key={i} item={product} />
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
